import comp from "./AITutorVideoModality";
export default comp;
